module.exports = __webpack_public_path__ + "img/kongjiemian.96555c7c.png";